module.exports = __webpack_public_path__ + "static/img/worth4.098f82cd.png";